/* eslint-disable */
import React from 'react';
import SelectInput from '../select_input/SelectInput.jsx';
import { NHB_MARKETS } from '../../constant.js';

const NHBCateringForm = ({
    nhbRestaurant, setNhbRestaurant,
    phoneNumber, setPhoneNumber,
    eventName, setEventName,
    guestCount, setGuestCount,
    dateSent, setDateSent,
    cateringDeadline, setCateringDeadline,
}) => {
    return (
        <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
            {/* Phone */}
            <div className="sm:col-span-3">
                <label htmlFor=" phoneNumber" className="block text-sm font-medium text-gray-900">
                    Phone Number
                </label>
                <input
                    id=" phoneNumber"
                    name=" phoneNumber"
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm"
                />
            </div>

            {/* Event Name */}
            <div className="sm:col-span-4">
                <label htmlFor="event-name" className="block text-sm font-medium text-gray-900">
                    Event Name
                </label>
                <input
                    id="event-name"
                    name="event-name"
                    type="text"
                    value={eventName}
                    onChange={(e) => setEventName(e.target.value)}
                    className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm"
                />
            </div>

            {/* Guest Count */}
            <div className="sm:col-span-2 sm:col-start-1">
                <label htmlFor="guest-count" className="block text-sm font-medium text-gray-900">
                    Approximate Guest Count
                </label>
                <input
                    id="guest-count"
                    name="guest-count"
                    type="text"
                    value={guestCount}
                    onChange={(e) => setGuestCount(e.target.value)}
                    className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm"
                />
            </div>

            {/* Date Sent */}
            <div className="sm:col-span-2">
                <label htmlFor="date-sent" className="block text-sm font-medium text-gray-900">
                    Date Sent
                </label>
                <input
                    id="date-sent"
                    name="date-sent"
                    type="date"
                    value={dateSent}
                    onChange={(e) => setDateSent(e.target.value)}
                    className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm"
                />
            </div>

            {/* Catering Deadline */}
            <div className="sm:col-span-2">
                <label htmlFor="catering-deadline" className="block text-sm font-medium text-gray-900">
                    Catering Deadline
                </label>
                <input
                    id="catering-deadline"
                    name="catering-deadline"
                    type="date"
                    value={cateringDeadline}
                    onChange={(e) => setCateringDeadline(e.target.value)}
                    className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline outline-1 outline-gray-300 focus:outline-2 focus:outline-primary-400 sm:text-sm/6"
                />
            </div>

            {/* NHB Market */}
            <div className="sm:col-span-6">
                <label htmlFor="location" className="block text-sm font-medium text-gray-900">
                    North High Brewing Restaurant
                </label>
                <SelectInput
                    options={NHB_MARKETS}
                    value={NHB_MARKETS.find((item) => item.value === nhbRestaurant)}
                    setSelectedValue={(selected) => setNhbRestaurant(selected.value)}
                    placeholder="Choose a NHB Market"
                    className="mt-2"
                    required
                />
            </div>
        </div>
    );
};

export default NHBCateringForm;
